import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

export const wrapper = css`
  display: block;
`;

export const content = css`
  width: 100%;

  p {
    margin: 0 0 var(${spacing.sm});
    font-size: var(${typography.body.sizes.lg.fontSize});
    line-height: var(${typography.body.sizes.lg.lineHeight});
  }
`;

export const heading = css`
  font-size: var(${typography.body.sizes.lg.fontSize});
  line-height: var(${typography.body.sizes.lg.lineHeight});
  font-weight: var(${typography.body.fontWeight});
  color: var(${colors.content.default});
  letter-spacing: var(${typography.body.letterSpacing});
  margin: var(${spacing.lg}) 0 var(${spacing.xs});
`;

export const ingredientsInfo = css`
  padding: var(${spacing.sm}) 0;
`;

export const fileLinkWrapper = css`
  cursor: pointer;
  display: flex;
  align-items: flex-start;
`;

export const fileLink = css`
  margin-left: var(${spacing.xs});
`;

export const fileIcon = css`
  align-self: flex-start;
`;
